export interface MenuItem {
  label: string;
  icon: string;
  disabled: boolean;
}

export interface MenuConfig {
  signInHeader: string;
  signInSubHeader: string;
  header: string;
  items: MenuItem[];
  defaultSelected: string;
}

/** Menu configurations keyed by URL segment */
export const MENU_CONFIGS: Record<string, MenuConfig> = {
  billing: {
    signInHeader: 'Billing & Payment',
    signInSubHeader: 'To make a payment fill in the policy number and at least one of the following fields.',
    header: 'Billing & Payment',
    items: [
      { label: 'Statement', icon: 'payments', disabled: false },
      { label: 'History', icon: 'log-history', disabled: false },
      { label: 'Receipts', icon: 'document', disabled: false },
      { label: 'Schedule', icon: 'calendar', disabled: false },
      { label: 'Pay Method', icon: 'Card-bank', disabled: false },
    ],
    defaultSelected: 'Statement',
  }
};
